"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMainMenuCharacterCustomizeState = void 0;
const Class_1 = require("../../../classes/Class");
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const definables_1 = require("definables");
const createMainMenuCharacterCustomizeState = ({ classID, }) => {
    const characterClass = (0, definables_1.getDefinable)(Class_1.Class, classID);
    const [clothesDyeItemPrimaryColorIndex, clothesDyeItemSecondaryColorIndex] = characterClass.clothesDyeItemOrderOffset;
    const figureIndex = characterClass.figureOrderOffset;
    const skinColorIndex = characterClass.skinColorOrderOffset;
    const hairDyeItemIndex = characterClass.hairDyeItemOrderOffset;
    const maskItemIndex = characterClass.maskItemOrderOffset;
    const outfitItemIndex = characterClass.outfitItemOrderOffset;
    const state = new pixel_pigeon_1.State({
        classID,
        clothesDyeItemPrimaryColorIndex,
        clothesDyeItemSecondaryColorIndex,
        direction: retrommo_types_1.Direction.Down,
        figureIndex,
        hairDyeItemIndex,
        maskItemIndex,
        outfitItemIndex,
        skinColorIndex,
    });
    return state;
};
exports.createMainMenuCharacterCustomizeState = createMainMenuCharacterCustomizeState;
